import { Header } from '../header/header';
import { PageLayout } from '@yarmill/components';
import { PropsWithChildren, ReactElement } from 'react';

export function Page({ children }: PropsWithChildren): ReactElement {
  return (
    <>
      <Header />
      <PageLayout>{children}</PageLayout>
    </>
  );
}
